var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwichIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 0C37.3137 0 40 2.68629 40 6V34C40 37.3137 37.3137 40 34 40H6C2.68629 40 1.28855e-07 37.3137 0 34V6C0 2.68629 2.68629 1.28851e-07 6 0H34ZM7.76953 11.8262V29.8418L8.01562 30.0879H13.6641C14.031 31.5047 13.6631 33.0115 13.8203 34.4365C13.8482 34.6838 13.8367 34.8424 14.0742 34.998L18.9092 30.1729L23.2568 29.9336L32.1748 20.999V6.91211L31.9297 6.66699H12.9287L7.76953 11.8262ZM30.0469 9.04199V19.8535L26.1133 23.7812L21.9727 23.8994C21.5075 24.037 19.5578 26.4012 18.9092 26.8975C18.7439 27.0236 18.7025 27.2136 18.416 27.1416V23.8652H13.9941V8.7959H29.8018L30.0469 9.04199ZM24.9688 18.2959H26.9346V12.3994H24.9688V18.2959ZM19.3984 18.2949H21.5273C21.5896 18.1181 21.3644 17.9375 21.3643 17.8867V12.3994H19.3984V18.2949Z",
    fill: "#A441F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_553_333246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1751 20.9988L23.2564 29.9339L18.9093 30.173L14.074 34.9984C13.8365 34.8428 13.848 34.684 13.8201 34.4366C13.6629 33.0116 14.0314 31.5047 13.6645 30.0879H8.01522L7.76953 29.8422V11.8263L12.9291 6.66675H31.9294L32.1751 6.91244V20.9988ZM18.4162 27.1412C18.7029 27.2132 18.7438 27.0232 18.9093 26.8971C19.5579 26.4008 21.5071 24.0373 21.9722 23.8997L26.113 23.7817L30.0473 19.8539V9.04178L29.8017 8.79609H13.9938V23.8653H18.4162V27.1412Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1114 23.7818L21.9707 23.8997L18.8513 26.9463C18.7283 27.0663 18.6658 27.2044 18.4147 27.1412V23.8653H13.9922V8.79614H29.8001L30.0458 9.04184V19.948L26.1114 23.7818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.364 12.3997V17.8868C21.364 17.9376 21.59 18.1178 21.5278 18.2947H19.3984V12.3997H21.364Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9343 12.3997H24.9688V18.2963H26.9343V12.3997Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_553_333246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.4055,
    height: 28.3333,
    fill: "white",
    transform: "translate(7.76953 6.66675)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwichIcon);
export default __webpack_public_path__ + "static/media/twich-icon.6e07745317a2ffddf92097749a83202b.svg";
export { ForwardRef as ReactComponent };